<template>
  <div v-if="showSubscriptionWarning" class="subscription-status">
    <!-- Expired Subscription Banner -->
    <div v-if="isExpired" class="subscription-expired">
      <div class="expired-content">
        <i class="bi bi-exclamation-triangle-fill"></i>
        <div class="expired-message">
          <h4>Your subscription has expired</h4>
          <p>Renew your subscription to continue accessing courses and exams.</p>
        </div>
        <router-link to="/pricing" class="btn btn-primary">
          Renew Now
        </router-link>
      </div>
    </div>
    
    <!-- Expiring Soon Warning -->
    <div v-else-if="isExpiringSoon" class="subscription-warning">
      <div class="warning-content">
        <i class="bi bi-clock-fill"></i>
        <div class="warning-message">
          <p>Your subscription expires in <strong>{{ daysUntilExpiry }}</strong> {{ daysUntilExpiry === 1 ? 'day' : 'days' }}</p>
        </div>
        <router-link to="/pricing" class="btn btn-sm btn-warning">
          Renew Early
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionStatus',
  computed: {
    user() {
      return this.$store.state.user;
    },
    
    isExpired() {
      return this.user && !this.user.is_subscription_active;
    },
    
    daysUntilExpiry() {
      return this.user ? this.user.days_until_expiry : 0;
    },
    
    isExpiringSoon() {
      return this.daysUntilExpiry > 0 && this.daysUntilExpiry <= 7;
    },
    
    showSubscriptionWarning() {
      // Don't show for admin users
      if (this.user && this.user.role_name === 'Admin') {
        return false;
      }
      return this.isExpired || this.isExpiringSoon;
    }
  }
};
</script>

<style scoped>
.subscription-status {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  z-index: 1030;
}

.subscription-expired,
.subscription-warning {
  padding: 15px 0;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.subscription-expired {
  background-color: #f8d7da;
  color: #721c24;
  border-bottom: 1px solid #f5c6cb;
}

.subscription-warning {
  background-color: #fff3cd;
  color: #856404;
  border-bottom: 1px solid #ffeaa7;
}

.expired-content,
.warning-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.expired-content i,
.warning-content i {
  font-size: 24px;
}

.expired-message h4 {
  margin: 0 0 5px 0;
  font-size: 18px;
}

.expired-message p,
.warning-message p {
  margin: 0;
}

.btn {
  white-space: nowrap;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .expired-content,
  .warning-content {
    flex-direction: column;
    text-align: center;
  }
  
  .expired-message,
  .warning-message {
    margin-bottom: 10px;
  }
}
</style>